var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('v-card',{staticClass:"mb-5",attrs:{"elevation":"3"}},[_c('v-card-title',{staticClass:"mainHeading"},[_vm._v(_vm._s(_vm.$t('anchors.settings')))])],1),_c('twofactor',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }